import script from "./Devices.vue?vue&type=script&setup=true&lang=ts"
export * from "./Devices.vue?vue&type=script&setup=true&lang=ts"

export default script